// Base
import { useState, useEffect } from "react";
import parse from "html-react-parser";

// Store
import { useTemplateStore } from "@/zustand/templateStore";

export default function Header() {
  const { colors, topBar, settings } = useTemplateStore();

  const initialSeconds: number = topBar.top_bar_time * 60;
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    if (secondsLeft <= 0) return;

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);

          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (sec: number) => {
    const minutes = Math.floor(sec / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (sec % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const headerStyle = colors?.top_bar_background
    ? { backgroundColor: colors.top_bar_background }
    : undefined;

  const countdownStyle = colors?.top_bar_time_text
    ? { color: colors.top_bar_time_text }
    : undefined;

  const hasTimer = topBar.tr_top_bar_label.includes("xx:xx");
  const [before, after] = topBar.tr_top_bar_label.split("xx:xx");

  return (
    <>
      {topBar?.show_top_bar && (
        <header
          className={`px-2 pt-2 pb-2 ${!colors?.top_bar_background ? "bg-cc-yellow" : ""}`}
          style={headerStyle}
        >
          <div
            className={`mx-auto w-fit text-center text-lg ${
              settings.enable_high_contrast
                ? "text-cc-dark-gray"
                : "text-cc-gray"
            }`}
          >
            {before && parse(before)}
            {hasTimer && initialSeconds > 0 && (
              <strong style={countdownStyle}>
                {parse(formatTime(secondsLeft))}
              </strong>
            )}
            {after && parse(after)}
          </div>
        </header>
      )}
    </>
  );
}
